import React, { useState } from 'react';
import { Container, Paper, Typography, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { changePasswordLegacy } from '../../services/accountsService';
import Sidebar from '../Sidebar/Sidebar';
import PasswordChangeForm from './PasswordChangeForm';
import { useSnackbar } from 'notistack';
import useAuth from '../../hooks/useAuth';

const ChangePassword = () => {
  const { t } = useTranslation();
  const [passwords, setPasswords] = useState({ old_password: '', new_password: '', confirm_password: '' });
  const { isLoggedIn, user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => setPasswords({ ...passwords, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (passwords.new_password !== passwords.confirm_password) {
      enqueueSnackbar(t('password.error_mismatch'), { variant: 'error' });
      return;
    }
    try {
      const response = await changePasswordLegacy(passwords, user.id);
      if (response.success) {
        enqueueSnackbar(t('password.success'), { variant: 'success' });
      } else {
        if (response.errors) {
          Object.keys(response.errors).forEach((key) =>
            enqueueSnackbar(`${key}: ${response.errors[key].join(' ')}`, { variant: 'error' })
          );
        } else {
          enqueueSnackbar(t('password.error_generic'), { variant: 'error' });
        }
      }
    } catch (error) {
      console.error('Error changing password', error);
      enqueueSnackbar(t('password.error_generic'), { variant: 'error' });
    }
  };

  return isLoggedIn ? (
    <>
      <Sidebar user={user} />
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
          <Typography variant="h4" gutterBottom>
            {t('password.change_title')}
          </Typography>
          <PasswordChangeForm
            passwords={passwords}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </Paper>
      </Container>
    </>
  ) : (
    <CircularProgress />
  );
};

export default ChangePassword;
